import {
  InfluencerForInfluencedBookStatusEnum,
  InfluencerStatsEnum,
} from '../enums/influencer-status.enum'

const statusColors: { [key: string]: string } = {
  [InfluencerStatsEnum.NOT_CONTACTED]: 'bg-[#D3D3D3]',
  [InfluencerStatsEnum.NO_RESPONSE]: 'bg-[#F9EEA2]',
  [InfluencerStatsEnum.INFLUENCER]: 'bg-[#E29DF8] ',
  [InfluencerStatsEnum.BLACKLISTED]: 'bg-[#EF9FAA] ',
  [InfluencerStatsEnum.SUPER_INFLUENCER]: 'bg-[#B89AF8] ',
  [InfluencerStatsEnum.INTERESTED]: 'bg-[#F2BF9D] ',
  [InfluencerForInfluencedBookStatusEnum.SELECTED]: 'bg-[#B4D887] ',
  [InfluencerForInfluencedBookStatusEnum.UNSELECTED]: 'bg-[#D3D3D3] ',
  [InfluencerForInfluencedBookStatusEnum.NA]: 'bg-[#D3D3D3] ',
}

export default statusColors
